<template>
    <div class="personal-index max-content">
        <div class="top">
            <img v-if="top_url" :src="top_url" />
        </div>
        <div class="KV">
            <img v-if="banner_url" :src="banner_url" />
        </div>
        <!-- <img class="avatar" :src="userInfo.avatar" v-if="userInfo.avatar" />
        <img class="avatar" src="@/assets/images/default_user.png" v-else /> -->

        <div class="update">
            <van-form input-align="right" error-message-align="right">
                <van-cell-group inset style="margin:0;display: flex;flex-direction: column;">
                    <p style="padding:10px;font-size:14px;color:#144A93;" v-if="updateDate">
                        最新个人信息修改时间:{{ updateDate }}
                    </p>
                    <van-field v-model="form.username" name="姓名" label="姓名" placeholder="请输入" 
                        :disabled="disabled"  />
                    <van-field v-model="form.mobile" name="手机号" label="手机号" placeholder="请输入"  disabled
                         />
                        <van-field v-model="form.hospital" name="单位" label="单位" placeholder="请输入" 
                        :disabled="disabled"  />
                    <van-field :value="title" is-link readonly clickable name="picker" label="职位" placeholder="请选择"
                        @click="disabled == false ? showProPicker = true : ''" 
                        :disabled="disabled" />
                    <van-popup v-model="showProPicker" position="bottom">
                        <van-picker show-toolbar :columns="columns" :default-index="defaultIndex" @confirm="onConfirm"
                            @cancel="showProPicker = false" />
                    </van-popup>
                   
                    <van-field class="field-intro" v-model="form.intro" name="简介" label="简介" type="textarea"
                        rows="1" input-align="left" label-align="left"
                        :autosize="{ minHeight: 60, maxHeight: 400 }"
                        :placeholder="disabled == true ? '' : '请输入'" error-message-align="center"
                        :disabled="disabled" />
                    <van-field name="uploader" input-align="center" v-model="form.photo"
                         error-message-align="center"
                        :disabled="disabled">
                        <template #input>
                            <van-uploader v-model="fileList" :max-count="1" :after-read="(file) => afterRead(file)"
                                :before-delete="(file) => beforeDelete(file)" :disabled="disabled"
                                :deletable="disabled == false">

                            </van-uploader>
                            <p>点击上传个人照片</p>
                            <p style="color:#B5B5B5;margin:0;">您的照片将用于会议手册和会议系统的制作</p>
                        </template>
                    </van-field>
                </van-cell-group>
                <div style="margin: 16px;">
                    <van-button block style="background-color:#B01C06;color:white;border-radius:10px;"
                        :disabled="buttonDisabled" @click="onSubmit">
                        {{ uploadText }}
                    </van-button>
                </div>
            </van-form>

        </div>
        <!-- <div class="back" @click="goUpload()" style="bottom:90px;">
            <img src="@/assets/images/collection/upload_report.png" />
      </div>
      <div class="back" @click="goIndex()">
            <img src="@/assets/images/collection/back_index.png" />
      </div> -->
    </div>
</template>

<script>
import { PersoanalUserInfo, Titles, uploadImg, preWriters, ExpertInformation, Provinces } from '../../../config/interface.js'
// import { Cascader } from 'vant';
export default {
    // comments:{
    //     Cascader
    // },
    data() {
        return {
            userInfo: {},
            form: {
                username: '',
                mobile: '',
                title: '',
                department: '',
                hospital: '',
                intro: '',
                photo: '',
            },
            addressValue: '',
            selectedAddress: [],
            title: '',
            showProPicker: false,
            showAddress: false,
            addressOptions: [],
            columns: [],
            fileList: [],
            uploadText: '提交个人信息',
            disabled: false,
            buttonDisabled: false,
            defaultIndex: 0,
            updateDate: '',
            id: this.$route.query.meeting_id,
            top_url: '',
            banner_url: ''
        }
    },
    created() {
        this.getUserInfo();
        this.getSetting();

    },
    methods: {
        //得到用户信息
        getUserInfo(val) {
            const url = PersoanalUserInfo;
            let params = {};
            const method = 'POST';
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        localStorage.setItem('userInfo', JSON.stringify(data));
                        this.$store.dispatch('storageUserInfo', data);
                        this.userInfo = data;
                        if (this.userInfo && this.userInfo.mobile_status == 1) {
                            this.form.mobile = this.userInfo.mobile;
                            if (!val) {
                                this.getTitles();
                            }
                        }
                        else {
                            common.toast('未绑定手机', 1000, 'fail', () => {
                                this.$router.replace({
                                    path: "/vascularNews/user/login?meeting_id=" + this.meeting_id,
                                    query: { url: window.location.href }
                                });
                            })
                        }
                    }
                })
        },
        getTitles() {
            const url = Titles;
            let params = {};
            const method = 'GET';
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        this.columns = [];
                        for (let i = 0; i < data.length; i++) {
                            this.columns.push(
                                { id: data[i].id, text: data[i].name }
                            );
                        }
                        this.getInfo();
                    }
                })

        },
        getProvinces() {
            const url = Provinces;
            let params = {
                parent_id: 0
            };
            const method = 'POST';
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        // this.addressOptions=res.data;
                        this.addressOptions = [];
                        res.data.forEach(item => {
                            this.addressOptions.push({
                                id: item.id,
                                name: item.name
                            })
                        })
                        console.log(this.addressOptions)
                    }
                })

        },

        onChange({ value, selectedOptions, tabIndex }) {
            const url = Provinces;
            let params = {
                parent_id: value
            };
            const method = 'POST';
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        console.log(selectedOptions)
                        if (tabIndex == 0) {
                            this.$set(selectedOptions[0], 'children', data)
                        }
                        else if (tabIndex == 1 && data.length > 0) {
                            this.$set(selectedOptions[1], 'children', data)
                        }
                        if ((tabIndex == 1 || tabIndex == 2) && data.length == 0) {
                            this.showAddress = false;
                            this.selectedAddress = selectedOptions;
                            this.form.address = selectedOptions.map((option) => option.name).join('/');
                            this.form.address_province_id = selectedOptions[0].id;
                            this.form.address_city_id = selectedOptions[1].id;
                            if (tabIndex == 2) {
                                this.form.address_district_id = selectedOptions[2].id;
                            }
                        }
                    }
                })

        },
        onFinish({ selectedOptions }) {
            // this.showAddress = false;
            // this.addressValue=selectedOptions;
            // if(selectedOptions.length==2&&selectedOptions[1]){

            // }
            // this.form.address = selectedOptions.map((option) => option.name).join('/');

        },
        getSetting() {
            const url = 'webapi/meetings/' + this.id + '/collects';
            //post必填参数，title,content，可选参数code
            let params = {};
            const method = 'GET';
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        this.top_url = data.top_img;
                        this.banner_url = data.banner;
                    }
                })
        },
        getWriterDetail() {
            const url = ExpertInformation;
            let params = {
                writer_id: this.userInfo.writer_id
            };
            const method = 'POST';
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        if (data.name) {
                            this.form.username = data.name;
                        }
                        if (data.title) {
                            this.columns.forEach((item, index) => {
                                if (item.id == data.title.id) {
                                    this.title = item.text;
                                    this.form.title = data.title.id;
                                    this.defaultIndex = index;
                                }
                            })
                        }
                        if (data.department) {
                            this.form.department = data.department;
                        }
                        if (data.company) {
                            this.form.hospital = data.company;
                        }
                        if (data.des) {
                            this.form.intro = data.des
                        }
                        if (data.photo) {
                            this.form.photo = data.photo;
                            this.fileList = [{ url: data.photo, isImage: true }];
                        }
                    }
                })

        },
        getInfo() {
            const url = preWriters;
            let params = {};
            const method = 'GET';
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        // if(false){
                        if (data) {
                            this.uploadText = '修改个人信息';
                            // this.disabled = true;
                            this.form.username = data.name;
                            this.form.mobile = data.mobile;
                            this.form.title = data.title_id;
                            this.form.department = data.department;
                            this.form.hospital = data.company;
                            this.form.intro = data.des;
                            this.form.photo = data.avatar;
                            this.fileList = [{ url: data.avatar, isImage: true }];
                            this.updateDate = this.transformDate(data.updated_at);
                            this.columns.forEach((item, index) => {
                                if (item.id == this.form.title) {
                                    this.title = item.text;
                                    this.defaultIndex = index;
                                }
                            })
                        }
                        else {
                            if (this.userInfo.is_writer) {
                                this.getWriterDetail();

                            }
                        }
                    }
                })

        },
        onSubmit() {
            console.log(this.disabled);
            // if (this.disabled == false) {
            // this.buttonDisabled = true;
            const url = preWriters;
            let params = {
                name: this.form.username,
                title_id: this.form.title,
                department: this.form.department,
                company: this.form.hospital,
                des: this.form.intro,
                avatar: this.form.photo,
                meeting_id: this.id,
            };
            const method = 'POST';
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        // this.buttonDisabled = false;
                        // this.disabled = true;
                        common.toast("提交成功！", 1000)
                        // this.uploadText = '修改个人信息';
                        // if (res.data.sttus == 1) {
                        //     this.getUserInfo(1);
                        //   
                        // }
                        this.updateDate = this.transformDate(res.data.updated_at);
                    }
                })
        },
        onConfirm(value) {
            this.title = value.text;
            this.form.title = value.id;
            this.showProPicker = false;
        },
        // goIndex(){
        //     this.$router.push({
        // 		path:'/collection/index',
        //         query:{
        //             id:this.id
        //         }
        // 	});
        // },
        // goUpload(){
        //     this.$router.push({
        // 		path:'/collection/subject',
        //         query:{
        //             id:this.id,
        //         }
        // 	});
        // },
        afterRead(file) {
            const url = uploadImg;
            let formData = new FormData();
            formData.append('file', file.file);
            const method = 'POST';
            fetch(url, formData, method)
                .then((res) => {
                    if (res.code == 0) {
                        this.form.photo = res.data.path;
                    }
                })
        },
        beforeDelete(file) {
            this.form.photo = '';
            return () => { }
        },
        transformDate(str) {
            if (str) {
                str = str.split(" ")[0];
                let arr = str.split("-");
                return arr[0] + "年" + arr[1] + "月" + arr[2] + "日";
            }
            return "";
        }


    }

}
</script>

<style lang="scss">
.personal-index {
    margin-bottom: 30px;

    .top {
        img {
            width: 100%;
        }
    }

    .KV {
        margin: 15px 15px 0;

        img {
            width: 100%;
            border-radius: 10px;
        }
    }

    .avatar {
        display: block;
        margin: 0 auto;
        border-radius: 50%;
        width: 60px;
        margin-top: -40px;
        border: 2px solid #8addeb;
        // 解决ios边框显示一半的问题
        transform: rotateZ(360deg);

    }

    .update {
        margin: 0 15px;
        border-radius: 5px;
        box-shadow: 0px 2px 4px #f2f2f2;

        .van-cell {
            line-height: 1rem;
            font-size: 16px;
        }
        
        .van-cell::after{
            border-bottom: 0.026667rem solid #ebedf0 !important;
        }
        .van-field__control--custom {
            display: block !important;
        }

        .field-intro.van-cell {
            flex-direction: column;
            align-items: stretch;
        }

        .field-intro .van-cell__title {
            flex: none !important;
            width: 100%;
            max-width: 100%;
            margin-right: 0;
            padding-bottom: 8px;
        }

        .field-intro .van-cell__value {
            flex: none !important;
            width: 100%;
            overflow: visible;
            text-align: left;
        }

        .field-intro .van-field__body {
            align-items: flex-start;
        }

        .field-intro textarea.van-field__control {
            white-space: pre-wrap;
            word-wrap: break-word;
            overflow-wrap: break-word;
            word-break: break-word;
            line-height: 1.5;
        }

        .van-cell__right-icon {
            line-height: 1rem;
        }

    }

    .back {
        position: fixed;
        right: 0;
        bottom: 30px;

        img {
            height: 40px;
        }
    }


}

.van-field--disabled .van-field__label {
    color: #323233 !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/User/Collection.vue